import { useEffect, useRef } from "react";

function WebLoading() {

    const loadingScreenRef = useRef(null);  
    useEffect(() => {
        const hideLoadingScreen = () => {
          if (loadingScreenRef.current) {
            loadingScreenRef.current.classList.add('hidden');  
          }
        };
        window.addEventListener('load', hideLoadingScreen);
        return () => window.removeEventListener('load', hideLoadingScreen);
      }, []);
 
    return (
      <>
       <div className="loading-screen" ref={loadingScreenRef} id="loading-screen">
            <div className="loading-content">
                <div className="spinner"></div>
                <p>Loading...</p>
            </div>
            </div>
      </>
    );
  }
  
  export default WebLoading;
  
  
  